/* FAQ accordion: toggle answers on the FAQs page */
(function ($) {
  $(document).on('click', '.faq__question', function () {
    $(this).toggleClass('active');
  });
})(jQuery);
